import styled from 'vue3-styled-components';

export const MainBoxSc = styled('div', ['visible'])`
  display: block;
  flex: 1;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 500;
  color: #333333;
  line-height: 24px;

  .picker {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;

    .picker-column {
      width: 100%;
      height: 220px;
      position: relative;
      overflow: hidden;

      /* 内容区域 start */
      ul,li {
        list-style: none;
      }

      .column-item {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
        height: 44px;
        font-family: 'PingFang SC-Medium', 'PingFang SC', 'Source Han Sans CN-Medium', 'Source Han Sans CN';
        color: #333;
        font-weight: 500;
      }
      /* 内容区域 end */
    }
    /* 遮罩层区域 start */
    .cover-border {
      position: absolute;
      z-index: 3;
      top: 50%;
      width: 100%;
      height: 44px;
      right: 0px;
      transform: translateY(-50%);
      pointer-events: none;
    }

    .cover-border::after{
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      top: -50%;
      right: -50%;
      bottom: -50%;
      left: -50%;
      /* border: 0 solid #ebedf0; */
      border: 0 solid #aaa;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      border-width: 1px 0;
    }

    .mask {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(180deg, hsla(0, 0%, 100%, 0.9), hsla(0, 0%, 100%, 0.5)), linear-gradient(0deg, hsla(0, 0%, 100%, 0.9), hsla(0, 0%, 100%, 0.5));
      background-repeat: no-repeat;
      background-position: top, bottom;
      background-size: 100% 88px;
      pointer-events: none;
    }
    /* 遮罩层区域 end */
  }
`;